module.exports = __webpack_public_path__ + "static/media/car.518274a1.svg";